<template>
  <v-row aling="center" justify="start" class="mx-0">

    <!-- skeleton loader -->
    <template v-if="$store.state.payments.retrieveLoader">
      <v-col cols="3" v-for="i in 4" :key="i">
        <v-skeleton-loader transition="fade-transition" type="article, actions" />
      </v-col>
    </template>
    <!-- end skeleton loader -->

    <!-- gateways -->
    <template v-else>
      <v-card class="ma-3 py-0 card-apps" v-for="d in gateways.filter(g => g.display)" :key="d.id" :to="{ name: d.view }" :elevation="0" :ripple="false" width="360">
        <v-responsive class="align-start" :aspect-ratio="4/1">
          <v-card-text>
            <v-list subheader two-line>
              <v-list-item class="pa-0" three-line>
                <v-list-item-content class="pa-0 justify-start">
                  <v-list-item-title>
                    <img class="d-block" :src="require(`@/assets/appAsset-brand--${d.id}.svg`)" height="30">
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-2 text--secondary subtitle-2 font-weight-medium">{{ d.name }}</v-list-item-subtitle>
                  <v-list-item-subtitle class="mt-1 caption text--primary">{{ d.description }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ma-0">
                  <v-icon v-if="providers.includes(d.id)" class="mt-1" color="green accent-4">mdi-check-circle</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-responsive>
      </v-card>
    </template>
    <!-- end gateways -->
  </v-row>
</template>
<script>
// libs & utils
import { mapState } from 'vuex'

// collections
import gateways from '../../collections/gateways'

// mixins
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    gateways: gateways
  }),
  computed: {
    ...mapState({
      providersList: state => state.payments.providersList
    }),
    providers () {
      return this.providersList.map(provider => provider.gateway)
    }
  },
  created () {
    this.$store.dispatch('payments/LIST', {
      resource: 'providers'
    })
  }
}
</script>